import api from 'shared/api';

export default {
  props: {
    mutualFundType: {
      type: String,
      default: null,
    },
    investmentManager: {
      type: String,
      default: null,
    },
    syariah: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Boolean,
      default: false,
    },
    filterMode: {
      type: String,
      default: 'product',
    },
  },
  data() {
    return {
      productResponse: [],
      state: 'loading',
      selectedValue: 'All',
    };
  },
  computed: {
    isSuccess() {
      return this.state === 'success';
    },
    isError() {
      return this.state === 'error';
    },
    isLoading() {
      return this.state === 'loading';
    },
    isProductFilterMode() {
      return this.filterMode === 'product';
    },
    renderedList() {
      return this.isProductFilterMode ? this.productTypes : this.custodianBanks;
    },
    productTypes() {
      if (this.products.length) {
        return this.products.reduce((types, product) => {
          if (types.indexOf(product.type) === -1) {
            types.push(product.type);
          }
          return types;
        }, []);
      }
      return [];
    },
    custodianBanks() {
      return Array.from(new Set(this.products.map(product => product.custodian_bank_name)));
    },
    products() {
      const result = this.sortProducts(this.productResponse);
      return this.filter ? result : this.filterProducts(result);
    },
  },
  created() {
    this.getProducts();
  },
  methods: {
    getProducts() {
      this.state = 'loading';
      api
        .getProducts()
        .then(({ data }) => {
          if (data) {
            this.state = 'success';
            this.productResponse = data;
          }
        })
        .catch(() => {
          this.state = 'error';
        });
    },
    sortProducts(products) {
      if (products.length) {
        return products.slice(0).sort((a, b) => {
          if (a.risk_indicator < b.risk_indicator) {
            return -1;
          }
          if (a.risk_indicator > b.risk_indicator) {
            return 1;
          }
          return 0;
        });
      }
      return [];
    },
    filterProducts(products) {
      if (this.mutualFundType) {
        return products.filter(product => product.type === this.mutualFundType);
      }

      if (this.investmentManager) {
        return products.filter(product => product.im_code === this.investmentManager);
      }

      if (this.syariah) {
        return products.filter(product => product.syariah);
      }

      return products;
    },
  },
};
